/* eslint-disable */
import React, { FC, useState, useContext, useEffect } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import India from './flags/IN.svg';
import { LoginContext } from './context/LoginContext';
import {LanguageContext} from './context/localization/languageState'
import ReCAPTCHA from 'react-google-recaptcha';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import Label from './atoms/label/label';
import Text from './atoms/text/text';
import BackArrow from './atoms/backArrow/backArrow';
import Dropdown from './atoms/dropdown/dropdown';
import LoaderLight from './atoms/loaderLight/loaderLight';
import loaderData from './assets/loader.json';

import 'react-responsive-modal/styles.css';
import './phoneNumber.scss';
import './newPurchase.scss';
import './rightSide.scss';

import { useHistory, Link } from 'react-router-dom';
import axios from 'axios';

const login = async (data) => {
    let returnData;
    await axios.post('/api/auth/login', data).then((res) => {
      console.log('------login RES', res);
      returnData = res;
    });
    console.log(returnData);
    return returnData;
  };

  const isCaptchaRequired = async (data) => {
    let returnData;
    await axios.post('/api/auth/is-captcha-req', data).then((res) => {
      returnData = res;
    });
    return returnData;
  };

  const setStorageId = () => {
    let storageId = new Date().getTime().toString();
    let charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let tokenLength = 40;
    let paddingChars = tokenLength - storageId.length;
    let i;
    for (i = 0; i < paddingChars; i++) {
      storageId = storageId + charset.charAt(Math.floor(Math.random() * charset.length));
    }
    if (localStorage && storageId) {
      localStorage.setItem('storageId', storageId);
    }
  }

  export const setDeviceId = async () => {
    let deviceId = generateFingerPrint();
    return deviceId.then(val => {
      localStorage.setItem('device_id', val);
      setDeviceIdHttpOnlyCookie(val);
    });
  }

const generateFingerPrint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const visitorId = result.visitorId;
    return visitorId;
  }

  const setDeviceIdHttpOnlyCookie = (deviceId) => {
    const body = getSetDeviceIdCookiePostBody(deviceId);
  //  console.log("===>> ",body)
    axios.post('/set-cookie', body);
  }

  const getSetDeviceIdCookiePostBody = (deviceId) => {
    return {
      cookieValue: deviceId,
      cookieKey: "device_id",
      overwrite: false
    };
  }

const PhoneNumber = ({ redirect }) => {
  const localization = useContext(LanguageContext)
  const history = useHistory();
  const currentLocation = history.location.pathname;
  // const { init, UseGTMHookProvider } = useGTM();
  const [selectedCountry, setSelectedCountry] = useState('');
  let localModalCountryList = [];
  const {
    phonenumber_header_text,
    phonenumber_header_subtext,
    generic_api_error_toast_message,
    digit_phone,
    mobile_number_text,
  } = localization.state.language;
  const {
    enterPhoneNumberText,
    enterOrCreateText,
    getStartedText,
    genericAPIErrorToastMessage,
    digitPhonePlaceholderText,
    nextText,
    userBlockedText,
    agreeTCText,
    tAndCText,
    privacyPolicyText,
    ampersandText,
    mobileNumberText,
  } = localization.state.language;


  const loginContext = useContext(LoginContext);
  const [phoneNumberValid, setPhoneNumberValid] = useState(false);
  const [iOSbtnNormal, setIOSbtnNormal] = useState('');
  const [iOSbtnEnabled, setIOSbtnEnabled] = useState('');
  const [iOScondition, setIOScondition] = useState('');
  const [isMweb, setIsMweb] = useState(false);
  const [showCountryListModal, setShowCountryListModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(
    loginContext.state.accountDetails.phoneNumber,
  );
  const [modalCountryList, setModalCountryList] = useState([]);
  const [showRecaptcha, setShowRecaptcha] = useState(false);
  const [showToast, setShowToast] = useState('none');
  const [toastMessage, setToastMessage] = useState('');
  const [userBlocked, setUserBlocked] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState(userBlockedText);
  const [phoneNumberClass, setPhoneNumberClass] = useState('input-phone-btn');
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
  const [loader, setLoader] = useState(false);
  const [captchaValid, setCaptchaValid] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const recaptchaRef = React.createRef();
  let recaptchaToken = '';

  const { search } = useLocation();

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  const appInit = () => {
    // init(gtmParams);
    setDeviceId();
    setStorageId();
  };

  const values = queryString.parse(search);
  let otherParams = [];

  let otherParamsVal = {};

  if (values) {
    Object.keys(values).forEach((key) => {
      const usualUTM = [
        'utm_source',
        'source',
        'utm_medium',
        'medium',
        'campaign',
        'utm_campaign',
        'term',
        'utm_term',
      ];
      if (usualUTM.includes(key)) {
        return;
      }

      otherParams = [...otherParams, key];
    });
  }

  if (otherParams) {
    otherParams.forEach((param) => {
      otherParamsVal = {
        ...otherParamsVal,
        [param]: values[param],
      };
    });
  }

  const sourceUTM = values.source ? values.source : values.utm_source;
  const campaignUTM = values.campaign ? values.campaign : values.utm_campaign;
  const mediumUTM = values.medium ? values.medium : values.utm_medium;
  const termUTM = values.term ? values.term : values.utm_term;

  let tempUTM = {};

  if (campaignUTM) {
    tempUTM = {
      ...tempUTM,
      campaign: campaignUTM,
    };
  }

  if (mediumUTM) {
    tempUTM = {
      ...tempUTM,
      medium: mediumUTM,
    };
  }

  if (termUTM) {
    tempUTM = {
      ...tempUTM,
      term: termUTM,
    };
  }

  useEffect(() => {
    console.log('Inside phone number')
    appInit()
    localStorage.removeItem('tokenC');
    setPhoneNumber('');
    handleResize();
    const $body = document.querySelector('body');
    window.addEventListener('resize', handleResize);
    let scrollPosition = window.pageYOffset;
    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';
    return () => {
      $body.style.removeProperty('overflow');
      $body.style.removeProperty('position');
      $body.style.removeProperty('top');
      $body.style.removeProperty('width');
      window.scrollTo(0, scrollPosition);
    }
  }, []);

  const handleResize = () => {
    if (window.innerWidth <= 1024) {
      setIsMweb(true);
    } else {
      setIsMweb(false);
    }
  };

  const openOTPModal = (setOtpErrorBoolean = false) => {
    history.push('/otp');
  };

  const clearAuthTokens = () => {
    document.cookie = `oem_auth_token=; expires= Thu, 21 Aug 2029 20:00:00 UTC`;
    document.cookie = `oem_refresh_token=; expires= Thu, 21 Aug 2029 20:00:00 UTC`;
    document.cookie = `oem_access_token=; expires= Thu, 21 Aug 2029 20:00:00 UTC`;
    console.log('Cleared authToken!');



    window.Moengage.add_user_attribute('oem_user_login_state', 'logout');
    window.Moengage.destroy_session();


    localStorage.removeItem('ph');
    localStorage.removeItem('em');
    localStorage.removeItem('nm');
  };

  useEffect(() => {

    if(getCookie('oem_auth_token')){
        //start
        axios
        .get('/api/auth/validateAuth', {
          headers: {
            oem_auth_token: getCookie('oem_auth_token'),
          },
        })
        .then((res) => {
          console.log('The validation status is ', res);
          //  history.push('/myReservations');
        })
        .catch((err) => {
          clearAuthTokens();
          console.log('The error is ', err);
        });
      //end
    }
   

    // bad indentation, will be corrected later
    setDeviceId().then((device_id) => {
      // Aditya + Habi: Finger Print can not be empty
      // We already have fingerprint.js & localstorage is already set with it
      // let fingerPrint = localStorage.getItem('device_id');

      // isCaptchaRequired({
      //   fingerPrint,
      //   storageId: localStorage.getItem('storageId'),
      // }).then((res) => {
      //   if (!redirect) {
          
      //   }

      //   localStorage.setItem('isCaptchaRequired', res?.data?.success);
      //   setShowRecaptcha(res?.data?.success);
      // });
    });
  }, []);

  useEffect(() => {

    if (window.webkit && window.webkit.messageHandlers) {
      try {
        window.webkit.messageHandlers.reservePage.postMessage({
          reserve: false,
        });
      } catch (e) {
        // console.log(e);
      }
    }

  }, [loginContext.state.countryList]);

  const reset = () => {
    setPhoneNumberValid(false);
    let accountDetails = {
      ...loginContext.state.accountDetails,
      verificationId: '',
      fullName: '',
      emailId: '',
      newUser: false,
      ivrInfo: null,
      mfaInfo: null,
      passwordInfo: null,
      showLink: false,
      otp: '',
      ssid: '',
    };
    loginContext.dispatch.setAccountDetails(accountDetails);
    loginContext.dispatch.setCaptchaToken('');
    setPhoneNumberClass('input-phone-btn');
  };

  const isPhoneInputValid = (val) => {
    if (parseInt(val, 10) && String(val).length === 10 && !(/^[0-5]/).test(String(val))) {
      return true;
    } else {
      return false;
    }
  };

  const inputPhoneChange = (e) => {
    if (loader) return;
    setLoader(false);
    //setUserBlocked(false);
    if (e.target.value &&  (/^[0-9]/gi).test(e.target.value)) {
      let val = e.target.value.replace(/[^\d]/g, '');
      if (val.length === 1 && val < 6) {
        return;
      }
      if (val.length > 10) {
        return;
      }
      if (isPhoneInputValid(val)) {
        setPhoneNumberValid(true);
        setNextButtonDisabled(false);
      } else {
        setNextButtonDisabled(true);
      }

      if (val.length > selectedCountry.maxNumberLength) {
        setPhoneNumber(
          val.slice(0, selectedCountry.maxNumberLength - val.length),
        );
      } else {
        let generalData = JSON.parse(localStorage.getItem('generalData'));
        generalData = {
          ...generalData,
          phoneNumber: parseInt(val, 10),
        };
        localStorage.setItem('generalData', JSON.stringify(generalData));
        //general data end
        setPhoneNumber(parseInt(val, 10));
      }
    } else {
      setPhoneNumber('');
      setNextButtonDisabled(true);
    }
  };

  const selectCountryFromDropdown = (country) => {
    setPhoneNumber('');
    let findCountry = countryList.find(
      (elem) => elem.countryCode === country.id,
    );
    setSelectedCountry(findCountry);
  };

  const selectCountry = (e) => {
    setPhoneNumber('');
    setShowCountryListModal(false);
    loginContext.dispatch.setSelectedCountry(
      loginContext.state.countryList.find(
        (elem) => elem.countryCode === e.currentTarget.id,
      ) || loginContext.state.selectedCountry,
    );
  };

  const phoneModalOnClick = async (token) => {
    setLoader(true);
    let accountDetails = {
      ...loginContext.state.accountDetails,
      phoneNumber: phoneNumber,
      captchaToken: token,
    };
    localStorage.setItem('tokenC', token);
    loginContext.dispatch.setAccountDetails(accountDetails);
    callLogin(phoneNumber, token);
  };

  const callLogin = (phoneNumber, recaptchaToken) => {
    let fingerPrint = localStorage.getItem('device_id');
    let captchaInfo = {
      fingerPrint,
      storageId: localStorage.getItem('storageId'),
    };
    // Aditya: The reCaptcha token should be removed completely
    // from the payload if it is not required.
    if (!showRecaptcha) {
      captchaInfo['gcaptcha'] = recaptchaToken;
    }
    let data = {
      mobileNumber: phoneNumber,
      dialingCode: loginContext.state.selectedCountry.dialingCode,
      countryCode: loginContext.state.selectedCountry.countryCode,
      headers: {},
      verificationId: null,
      captchaInfo,
    };
    //general data start
    let generalData = JSON.parse(localStorage.getItem('generalData'));
    generalData = {
      ...generalData,
      dialingCode: loginContext.state.selectedCountry.dialingCode,
      countryCode: loginContext.state.selectedCountry.countryCode,
    };
    localStorage.setItem('generalData', JSON.stringify(generalData));

    login(data).then(
      (res) => {
        console.log(`API Resposse ${JSON.stringify(res)}`)
        openOTPModal();
        const {
          data: { loginRequired, needCaptcha, message, status },
        } = res;
        if (status?.toString()?.toLowerCase() === 'success') {
          // handling a specific edge case
          // [start]
          if (needCaptcha) {
            setShowRecaptcha(false);
            localStorage.setItem('isCaptchaRequired', false);
            setBlockedMessage(message); // "Invalid Captcha!"
          }
          // [end]

          const accountDetails = {
            ...loginContext.state.accountDetails,
            phoneNumber: phoneNumber,
            verificationId: res.data.verificationId,
            newUser: res.data.newUser,
          };
          loginContext.dispatch.setAccountDetails(accountDetails);

          let tempNewUserFlag = res.data.newUser;

          // loginErrorCallback(null, status, needCaptcha, message, grecaptcha, data);
          
        } else {
          // loginErrorCallback(null, status, needCaptcha, message, grecaptcha, data);
        }
      },
      (err) => {
        console.log(`API Error -> ${err}`)
        // loginErrorCallback(err, null, needCaptcha, message, grecaptcha, data);
      },
    );
  };

  const loginErrorCallback = (
    err,
    status,
    needCaptcha,
    message,
    grecaptcha,
    data,
  ) => {
    // if err is not null, then it means
    // it occurred because of a 500-server error

    if (err) {
      setToastMessage(generic_api_error_toast_message);
      setShowToast('block');
      setTimeout(() => {
        setShowToast('none');
      }, 1000);
    }

    setLoader(false);
    //setUserBlocked(true);
    //setPhoneNumberClass('input-phone-btn-error');
    if (needCaptcha) {
      setCaptchaValid(false);
      setShowRecaptcha(false);
      localStorage.setItem('isCaptchaRequired', false);
      // setBlockedMessage(message); // "Invalid Captcha!"
      // recaptchaRef?.current && recaptchaRef.current.reset();
      // grecaptcha && grecaptcha.reset();
      // setNextButtonDisabled(true);
      setToastMessage('Invalid captcha');
      setShowToast('block');
      setTimeout(() => {
        setShowToast('none');
      }, 1000);
    }

    // if it's already a failure, then it means
    // the user has been blocked temporarily
    // here, we have to show the default message `userBlockedText`
    // if( status?.toString()?.toLowerCase() === 'failure') {
    //   setBlockedMessage(userBlockedText);
    // }

  };

  const getCaptchaKey = () => {
    return new Promise((resolve, reject) => {
    let config = {
      method: 'get',
      url: `/api/auth/getCaptchaKey`,
    };
    axios(config)
      .then((resp) => {
        if (resp?.data) {
          console.log('CaptchaKey url ', resp.data);
          resolve(resp?.data?.CAPTCH_SITE_KEY);
        }
      })
      .catch((err) => {
        console.log(err);
        reject(err)
      });
    })
  };

  const captchaOnExpired = () => {
    setCaptchaValid(false);
    setLoader(false);
    setNextButtonDisabled(true);
  };

  const captchaOnErrored = () => {
    setCaptchaValid(false);
    setLoader(false);
    setNextButtonDisabled(true);
  };

  const captchaOnChange = () => {
    // console.log(`recaptchaRef.current.getValue`, recaptchaRef.current.getValue());
    setCaptchaValid(true);
    setUserBlocked(false);
    setLoader(false);
    setNextButtonDisabled(false);

    // if (
    //   isPhoneInputValid(phoneNumber) &&
    //   showRecaptcha &&
    //   recaptchaRef.current.getValue()
    // )
    //   setPhoneNumberValid(true);
  };

  const onSubmit = async(captchaRes) => {
    console.log("captchaRes1:");
    // let captchaRes = window.grecaptcha.getResponse();
    let site_key = await getCaptchaKey();
    grecaptcha.ready(function() {
      if(site_key){
        grecaptcha.execute(site_key, { action: 'submit' }).then(function (token) {
          console.log('refreshed token verify:', token);
            phoneModalOnClick(token);
        });
      }
    });
  }
  
  const onBlurPhoneInput = () => {
    setIOSbtnNormal('');
    setIOSbtnEnabled('');
    setIOScondition('');
    if (phoneNumber === '') {
      setNextButtonDisabled(true);
      setPhoneNumberClass('input-phone-btn');
    } else {
      // setNextButtonDisabled(false);
      // return;
    }
  };

  const nextButtonClick = (evt) => {
    evt.preventDefault();
    localStorage.removeItem('oem_auth_token')
    if (showRecaptcha && !captchaValid) {
      setShowToast('block');
      setToastMessage('Please verify reCAPTCHA.');

      setTimeout(() => {
        setShowToast('none');
      }, 2000);
      return;
    }
    if (isPhoneInputValid(phoneNumber)) {
      //reCaptch verified
      //reCaptch also not required if `/api/auth/is-captcha-req`
      //api returns `{success: false}`
      var response = showRecaptcha ? grecaptcha.getResponse() : null;
      setPhoneNumberValid(true);
      setNextButtonDisabled(false);
      setPhoneNumberClass('input-phone-btn input-phone-btn-success');
      onSubmit(response);
      //start recaptcga
      // window.grecaptcha.render('submit', {
      //   sitekey: '6Ld6ZqYaAAAAACU7HyW_jQ2FTjCFc1ROg6clz_9G',
      //   callback: onSubmit,
      //   size: 'invisible',
      //   badge: 'bottomright',
      //   lang: 'en',
      // });
      // window.grecaptcha.execute();
    } else {
      setPhoneNumberClass('input-phone-btn input-phone-btn-error');
    }
  };
  const onPhoneFocus = () => {
    setPhoneNumberClass('input-phone-btn input-phone-btn-success');
    setIOSbtnNormal('nextBtn-np-ios');
    setIOSbtnEnabled('nextBtn-np-enabled-ios');
    setIOScondition('condition-text-np-ios');
  };

  return (
    <>
      <div className="new-purchase-main-container">

        <div className="right-container">
          {/* <Link to="/selectVariant" className="mweb-phone-arrow">
            <BackArrow />
          </Link> */}

          <div className="vertical-center" style={{ height: '90%' }}>
            <div className="phone-number-container">
              <div className="phone-field-section">
                <div className="phone-top-texts">
                  <Label
                    className="phone-number-text"
                    text={
                       getStartedText
                    } //enterPhoneNumberText}
                  />
                  <Label
                    className="phone-number-subtext"
                    text={enterOrCreateText}
                  />
                </div>

                <div className="phone-input-container">
                  <form onSubmit={nextButtonClick}>
                    <div
                      className={phoneNumberClass}
                      onFocus={onPhoneFocus}
                      onBlur={onBlurPhoneInput}
                    >
                      {isMweb ? (
                        // <Link to="/countryList">
                        <span className="country-select-span">
                          <img
                            src={
                              loginContext.state.selectedCountry
                                ? India //loginContext.state.selectedCountry.countryFlag
                                : India
                            }
                            alt=""
                          />
                          <Text
                            Class="code-btn"
                            textValue={
                              loginContext.state.selectedCountry
                                ? loginContext.state.selectedCountry.dialingCode
                                : '+91'
                            }
                          />
                          {/* <img className="arrow-down-btn" src={Arrow} alt="" /> */}
                        </span>
                      ) : (
                        // </Link>
                        <Dropdown
                          disableClick={true}
                          buttonContent={
                            <span className="country-select-span">
                              <img
                                src={
                                  selectedCountry
                                    ? India //selectedCountry.countryFlag
                                    : India
                                }
                                alt=""
                              />
                              <Text
                                Class="code-btn"
                                textValue={
                                  selectedCountry
                                    ? selectedCountry.dialingCode
                                    : '+91'
                                }
                              />
                              {/* <img
                              className="arrow-down-btn"
                              src={Arrow}
                              alt=""
                            /> */}
                            </span>
                          }
                          onItemSelect={(country) =>
                            selectCountryFromDropdown(country)
                          }
                          data={modalCountryList}
                        />
                      )}
                      <input
                        className="phone-number"
                        value={phoneNumber}
                        type="tel"
                        onChange={(e) => inputPhoneChange(e)}
                        placeholder={mobileNumberText}
                      />
                    </div>
                  </form>
                </div>
                {/* {showRecaptcha && (
                  <div className="captcha-container">
                    <div
                      className="g-recaptcha"
                      data-sitekey={process.env.RECAPTCHA_SITE_KEY}
                    ></div>
                  </div>
                )} */}
                {showRecaptcha ? (
                  <div className="captcha-container">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.RECAPTCHA_SITE_KEY || '6Leca5UbAAAAAP_zhdiUaVpE9tI3UDIdeVsiwqgs'}
                      onChange={captchaOnChange}
                      onExpired={captchaOnExpired}
                      onErrored={captchaOnErrored}
                    />
                  </div>
                ) : (
                  ''
                )}

                {userBlocked && (
                  <div className="error-box">
                    <span className="blocked-user-text">{blockedMessage}</span>
                  </div>
                )}
              </div>
              <div className="nextbtn-container margin-40">
                {loader ? (
                  <button
                    className={`nextBtn-np ${iOSbtnNormal}`}
                    onClick={nextButtonClick}
                    disabled={nextButtonDisabled}
                  >
                    <div className="loader-container-np">
                      <LoaderLight
                        loaderData={loaderData}
                        loaderStyle="loader-light-np"
                      />
                    </div>{' '}
                  </button>
                ) : (
                  <button
                    id="submit"
                    className={
                      nextButtonDisabled
                        ? `nextBtn-np ${iOSbtnNormal}`
                        : `nextBtn-np-enabled ${iOSbtnEnabled} `
                    }
                    onClick={nextButtonClick}
                    disabled={nextButtonDisabled}
                  >
                    {nextText}
                  </button>
                )}{' '}
              </div>
              <div className="flex-the-condition">
                <p className={`condition-text-np ${iOScondition}`}>
                  {agreeTCText}{' '}
                  <span className="text-underline-np">
                    <Link to="/tnc" target="_self">
                      {tAndCText}
                    </Link>
                  </span>{' '}
                  {ampersandText}{' '}
                  <span className="text-underline-np">
                    <Link to="/policy" target="_self">
                      {privacyPolicyText}
                    </Link>
                  </span>
                </p>
              </div>
              <div className="flex-the-toast">
                <div style={{ display: showToast }} className="custom-toast">
                  {toastMessage}{' '}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhoneNumber;
